<template>
<div>
    
     <v-text-field
        prepend-icon="mdi-magnify"
        label="Search Phone Numbers"
        style="margin-top: 15px;"
        v-model="search_text"
        autocomplete="off"
    />

    <v-data-table
        :headers="phone_number_headers"
        :items="profile.employee_endpoints"
        :search="search_text"
        :items-per-page="100"
        :hide-default-footer="true"
        class="elevation-1"
        style="margin-top: 15px;"

        :footer-props="{
            disableItemsPerPage: true,
            disablePagination: true,
            }"
    >
       <template v-slot:item.endpoint="{ item }">
            {{prettyPrintUsPhoneNumber(item.endpoint)}}
        </template>

        <template v-slot:item.is_primary="{ item }">
            <v-simple-checkbox v-model="item.is_primary" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.complimentary_endpoint="{ item }">
            <v-simple-checkbox
            v-model="item.complimentary_endpoint"
            disabled
            ></v-simple-checkbox>
        </template>

         <template v-slot:item.is_home_endpoint="{ item }">
            <v-simple-checkbox
            v-model="item.is_home_endpoint"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.supports_voice="{ item }">
            <v-simple-checkbox
            v-model="item.supports_voice"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.supports_messaging="{ item }">
            <v-simple-checkbox
            v-model="item.supports_messaging"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.expected_to_be_in_service="{ item }">
            <v-simple-checkbox
                v-model="item.expected_to_be_in_service"
                disabled
            />
        </template>

        

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
            >
                
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    
                    
                   <v-list-item
                        v-on:click="makeHome(item)"
                        v-show="can_write && !item.is_home_endpoint"
                    >
                        <v-list-item-title>Make home phone number...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickChangeLabel(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Change label...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="toggleComplimentary(item)"
                        v-if="is_system_admin"
                    >
                        <v-list-item-title>Toggle Complimentary</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="viewConversations($event,item)"
                    >
                        <v-list-item-title>View conversations...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickEditContactCards(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Edit contact cards...</v-list-item-title>
                    </v-list-item>

                </v-list>
            </v-menu>


        </template>

    </v-data-table>

    <div
        style="text-align: right; margin-top: 15px;"
    >
        <v-btn
            v-on:click="onClickFollowing"
        >
            Following...
        </v-btn>
    </div>

    <m-choose-vcard-dialog
        ref="edit-vcard-dialog"
        title="Edit contact cards"
        :action_text="null"
    />
    
</div>
</template>

<script>
const E164 = require("@/js/E164.js");

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            search_text: null,
        }
    },

    methods: 
    {
        prettyPrintUsPhoneNumber(endpoint)
        {
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        makeHome(item)
        {
            this.$rc.confirm(
                'Make Home',
                "Make "+this.prettyPrintUsPhoneNumber(item.endpoint)+" your home phone number?",
                [
                    {'text' : 'Cancel', 'value' : null },
                    {'text' : 'Make Home', 'value' : 'ok' },
                ],

                (response) => {
                    let changes = {
                        'endpoint' : item.endpoint,
                        'override_home_for_employee_id' : this.$route.params.employee_id
                    };

                    this.$emit('patch-endpoint', changes);
                }
            );
        },

        onClickChangeLabel(item)
        {
            this.$rc.alert('Change Label', 'Phone number lables are the same for all users of your organization.<br/><br/>To change a phone number\'s label: <ol><li>Go to the main menu</li><li>Choose Organization Settings</li><li>Navigate to the RedChirp Phone Number Settings section</li><li>Open the action menu for the phone number you want to change</li><li>Choose \'Change Label...\'</li><ol>');
        },

        viewConversations(event, endpoint)
        {
            this.$rc.toHomeForEndpoint(this.$router, endpoint.endpoint, event.shiftKey == true);
        },

        toggleComplimentary(item)
        {
            let changes = {
                'endpoint' : item.endpoint,
                'complimentary_endpoint' : !item.complimentary_endpoint,
            };


            this.$emit('patch-endpoint', changes);
            
        },

        onClickFollowing()
        {
            this.$router.push({
                'name': 'employee-following',
                'params' : {
                    'employee_id' : this.$route.params.employee_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        onClickEditContactCards(item)
        {
            let search = {
                'organization_id': item.organization_id,
                'for_organization_owned_endpoint' : item.endpoint,
            };

            this.$refs['edit-vcard-dialog'].showDialog(search);
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        phone_number_headers() {
            
            let ret = [
                { text: 'Phone Number', value: 'endpoint' },
                { text: 'Active', value: 'expected_to_be_in_service' },
                { text: 'Voice', value: 'supports_voice' },
                { text: 'Messaging', value: 'supports_messaging' },

                { text: 'Assignment', value: 'assignment_label' },
                { text: 'Label', value: 'label' },
                { text: 'Home', value: 'is_home_endpoint' },
                { text: 'Action', value: 'action', align: 'end' },
            ];

            if ( this.profile != null && this.profile.actor_permissions.is_system_admin )
            {
                ret.splice(4,0,{ text: 'Network', value: 'network' });
                ret.splice(8,0,{ text: 'Complimentary', value: 'complimentary_endpoint' });
            }

            return ret;
        },

        is_system_admin() {
            if ( this.profile == null ) return false;
            return this.profile.actor_permissions.is_system_admin;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>